import { endpoint } from './config'

export const axiosDefaultConfig = {
  basePath: endpoint
}
